<template>
	<span class="activity-type-pill" :class="`pill-${variant || type}`">
		<component :is="icon" v-if="icon" type="regular" class="pill-icon" />
		<span class="pill-label" v-text="displayLabel" />
	</span>
</template>

<script>
import {
	MessageIcon,
	ReplyIcon,
	FaceSmileIcon,
	SquarePollHorizontalIcon,
	ReelIcon,
	CircleExclamationIcon,
} from '@/icons'
import { markRaw } from 'vue'

const TYPE_CONFIG = {
	message: {
		icon: markRaw(MessageIcon),
		labelKey: 'admin_activity_type_message',
	},
	reply: { icon: markRaw(ReplyIcon), labelKey: 'admin_activity_type_reply' },
	reaction: {
		icon: markRaw(FaceSmileIcon),
		labelKey: 'admin_activity_type_reaction',
	},
	poll_response: {
		icon: markRaw(SquarePollHorizontalIcon),
		labelKey: 'admin_activity_type_poll_response',
	},
	chat_event: {
		icon: markRaw(CircleExclamationIcon),
		labelKey: 'admin_activity_type_event',
	},
}

const VARIANT_CONFIG = {
	thread: { icon: markRaw(ReelIcon), labelKey: null },
	deleted: { icon: null, labelKey: 'admin_activity_pill_deleted' },
}

export default {
	name: 'ActivityTypePill',

	props: {
		type: {
			type: String,
			default: null,
			validator: (v) => v === null || v in TYPE_CONFIG,
		},
		variant: {
			type: String,
			default: null,
			validator: (v) => v === null || v in VARIANT_CONFIG,
		},
		label: { type: String, default: null },
	},

	computed: {
		config() {
			if (this.variant) return VARIANT_CONFIG[this.variant]
			return TYPE_CONFIG[this.type] || {}
		},

		icon() {
			return this.config.icon || null
		},

		displayLabel() {
			if (this.label) return this.label
			return this.config.labelKey ? this.$t(this.config.labelKey) : ''
		},
	},
}
</script>

<style lang="scss" scoped>
.activity-type-pill {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 12px;
	border-radius: 30px;
	font-family: Avenir-Roman;
	font-size: 14px;
	line-height: 20px;
	color: var(--neutral-800);
	white-space: nowrap;

	.pill-icon {
		font-size: 16px;
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}
}

.pill-message {
	background: var(--interaction-message-bg);
}

.pill-reply {
	background: var(--interaction-reply-bg);
}

.pill-reaction {
	background: var(--interaction-reaction-bg);
	.pill-icon {
		font-size: 14px;
		width: 14px;
		height: 14px;
	}
}

.pill-poll_response {
	background: var(--teal-100);
	.pill-icon {
		font-size: 15px;
		width: 15px;
		height: 15px;
	}
}

.pill-chat_event {
	background: var(--interaction-event-bg);
	.pill-icon {
		font-size: 14px;
		width: 14px;
		height: 14px;
	}
}

.pill-thread {
	background: var(--neutral-100);
}

.pill-deleted {
	background: var(--interaction-deleted-bg);
	color: var(--interaction-deleted-accent);
}
</style>
